type ElearningChapterListIconProps = { src: string; alt: string };
export function ElearningChapterListIcon({
  src,
  alt,
}: ElearningChapterListIconProps) {
  return <img src={src} alt={alt} width="32px" height="32px" loading="lazy" />;
}
